import React from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '../../icons';

interface LowConfidenceNavigatorProps {
  isActive: boolean;
  totalCount: number;
  currentIndex: number;
  onNext: () => void;
  onPrev: () => void;
}

const LowConfidenceNavigator: React.FC<LowConfidenceNavigatorProps> = ({
  isActive,
  totalCount,
  currentIndex,
  onNext,
  onPrev,
}) => {
  if (totalCount === 0) {
    return null;
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (e.shiftKey) {
        onPrev();
      } else {
        onNext();
      }
    }
  };

  return (
    <div
      data-tutorial="low-confidence-navigator"
      className="relative inline-flex items-center px-3 py-2 text-xs text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 whitespace-nowrap"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      role="button"
      aria-label="Navigate low confidence words"
    >
      {/* Status text */}
      <span
        className="pr-12 whitespace-nowrap"
        title="Low confidence words (Click to focus, Enter/Shift+Enter to navigate)"
      >
        {isActive ? (
          <>
            ⚠️ {currentIndex + 1} / {totalCount}
          </>
        ) : (
          <>⚠️ {totalCount}</>
        )}
      </span>

      {/* Navigation arrows - positioned absolutely on the right */}
      <div className="absolute right-1 top-1/2 transform -translate-y-1/2 flex items-center space-x-0.5">
        <button
          onClick={onPrev}
          className="p-0.5 rounded hover:bg-red-100 dark:hover:bg-red-800/30 transition-colors"
          title="Previous low-confidence word (Shift+Enter)"
        >
          <ChevronUpIcon size={14} className="text-red-600 dark:text-red-400" />
        </button>
        <button
          onClick={onNext}
          className="p-0.5 rounded hover:bg-red-100 dark:hover:bg-red-800/30 transition-colors"
          title="Next low-confidence word (Enter)"
        >
          <ChevronDownIcon
            size={14}
            className="text-red-600 dark:text-red-400"
          />
        </button>
      </div>
    </div>
  );
};

export default LowConfidenceNavigator;
